import { AppProvider } from './contexts/AppContext';
import { useAppContext } from './contexts/hooks';
import { useWagmiSync } from './hooks/useWagmiSync.ts';
import { useSolanaSync } from './hooks/useSolanaSync.ts';
import Header from './components/Header';
import Footer from './components/Footer';
import { useEffect } from 'react';
import { trackPageView } from './lib/analytics.ts';
import * as Sentry from '@sentry/react';

import ConnectWallet from './pages/ConnectWallet';
import SelectBroker from './pages/SelectBroker';
import AccountOverview from './pages/AccountOverview';
import AccountAction from './pages/AccountAction';
import { OdsButton } from './components/orderly/OdsButton';
import { SectionCard } from './components/orderly/SectionCard';

function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 text-center">
      <SectionCard className="max-w-md">
        <h1 className="font-display text-2xl text-[var(--fg-base)]">Something went wrong</h1>
        <p className="mt-3 text-sm leading-6 text-[var(--fg-secondary)]">
          We've been notified and are working on it. Please refresh the page to try again.
        </p>
        <OdsButton className="mt-6" onClick={() => window.location.reload()}>
          Refresh Page
        </OdsButton>
      </SectionCard>
    </div>
  );
}

function Router() {
  const { state } = useAppContext();
  switch (state.page) {
    case 'connect': return <ConnectWallet />;
    case 'select_broker': return <SelectBroker />;
    case 'account_overview': return <AccountOverview />;
    case 'account_action': return <AccountAction />;
  }
}

function AppInner() {
  const { state } = useAppContext();
  useWagmiSync();
  useSolanaSync();

  useEffect(() => {
    trackPageView(`/${state.page}`);
  }, [state.page]);

  return (
    <div className="app-shell">
      <div className="app-shell-bg" aria-hidden="true">
        <div className="app-shell-orb app-shell-orb-primary" />
        <div className="app-shell-orb app-shell-orb-secondary" />
      </div>
      <Header />
      <main className="app-main">
        <Router />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <AppProvider>
        <AppInner />
      </AppProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
